export default "__VITE_ASSET__BcS5U_WR__"